/* eslint-disable import/prefer-default-export */
export const makeAvatar = name => name.substr(0, 1);
